/*
 * Global light/dark theming for beyondrepair.us
 * - Flips [data-theme] on <html> instantly (no fade) and persists to
 *   localStorage ('br-theme') so the choice carries across every page.
 * - Injects the corner toggle on every page (once), unless one is
 *   already hard-coded in the markup.
 * - No-flash init happens earlier in <head> via snippet 'theme-mode'.
 */
(function () {
  var KEY = 'br-theme';

  function currentMode() {
    return document.documentElement.getAttribute('data-theme') === 'light'
      ? 'light'
      : 'dark';
  }

  function setMode(mode) {
    document.documentElement.setAttribute('data-theme', mode);
    try {
      localStorage.setItem(KEY, mode);
    } catch (e) {}
  }

  function iconMarkup() {
    var rays = '';
    for (var i = 0; i < 12; i++) {
      rays +=
        '<path d="M12 3.6q1.2 1.3 0 2.7q-1.2 1.4 0 2.8" transform="rotate(' +
        i * 30 +
        ' 12 12)"/>';
    }
    var sun =
      '<svg class="br-theme-toggle__icon br-theme-toggle__sun" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="11" stroke-width="1.3"/>' +
      '<circle cx="12" cy="12" r="3.5" fill="currentColor" stroke="none"/>' +
      '<g stroke-width="1.5" stroke-linecap="round">' + rays + '</g></svg>';
    var moon =
      '<svg class="br-theme-toggle__icon br-theme-toggle__moon" viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1.3"/>' +
      '<path fill="currentColor" transform="translate(12 12) scale(0.62) translate(-12 -12)" d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';
    return sun + moon;
  }

  function ensureToggle() {
    if (!document.body || document.querySelector('.br-theme-toggle')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'br-theme-toggle';
    b.setAttribute('data-theme-toggle', '');
    b.setAttribute('aria-label', 'Switch between light and dark mode');
    b.title = 'Light / dark';
    b.innerHTML = iconMarkup();
    document.body.appendChild(b);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureToggle);
  } else {
    ensureToggle();
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-theme-toggle]');
    if (!toggle) return;
    event.preventDefault();
    setMode(currentMode() === 'light' ? 'dark' : 'light');
  });
})();
